import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Commodities from "@/pages/Commodities";
import Process from "@/pages/Process";
import Suppliers from "@/pages/Suppliers";
import Trust from "@/pages/Trust";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import DealIntake from "@/pages/DealIntake";
import DealDetail from "@/pages/DealDetail";
import Logistics from "@/pages/Logistics";
import Admin from "@/pages/Admin";
import AdminDeals from "@/pages/AdminDeals";
import AdminDealDetail from "@/pages/AdminDealDetail";
import Compliance from "@/pages/Compliance";
import AdminCompliance from "@/pages/AdminCompliance";
import AdminComplianceDetail from "@/pages/AdminComplianceDetail";
import SupplierDashboard from "@/pages/SupplierDashboard";
import SupplierProfile from "@/pages/SupplierProfile";
import SupplierAgreements from "@/pages/SupplierAgreements";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id during render to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/commodities" element={<Commodities />} />
      <Route path="/process" element={<Process />} />
      <Route path="/suppliers" element={<Suppliers />} />
      <Route path="/trust" element={<Trust />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/dashboard/deals" element={<ProtectedRoute><DealIntake /></ProtectedRoute>} />
      <Route path="/dashboard/deals/:id" element={<ProtectedRoute><DealDetail /></ProtectedRoute>} />
      <Route path="/dashboard/logistics" element={<ProtectedRoute><Logistics /></ProtectedRoute>} />
      <Route path="/dashboard/compliance" element={<ProtectedRoute><Compliance /></ProtectedRoute>} />
      <Route path="/compliance" element={<ProtectedRoute><Compliance /></ProtectedRoute>} />
      <Route path="/dashboard/supplier" element={<ProtectedRoute><SupplierDashboard /></ProtectedRoute>} />
      <Route path="/dashboard/supplier-profile" element={<ProtectedRoute><SupplierProfile /></ProtectedRoute>} />
      <Route path="/dashboard/supplier-agreements" element={<ProtectedRoute><SupplierAgreements /></ProtectedRoute>} />

      <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
      <Route path="/admin/deals" element={<ProtectedRoute requireAdmin><AdminDeals /></ProtectedRoute>} />
      <Route path="/admin/deals/:id" element={<ProtectedRoute requireAdmin><AdminDealDetail /></ProtectedRoute>} />
      <Route path="/admin/compliance" element={<ProtectedRoute requireAdmin><AdminCompliance /></ProtectedRoute>} />
      <Route path="/admin/compliance/:id" element={<ProtectedRoute requireAdmin><AdminComplianceDetail /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
